import Cookies from "js-cookie";

export function setTypeOfCatalogGrid(value) {
  Cookies.set("type_of_catalog_grid", value);
}
